import { useSelector } from "react-redux";
import MovieList from "./MovieList";

const SecondaryContainer = () => {
  const nowPlayingMovies = useSelector(
    (store) => store.movies?.nowPlayingMovies
  );
  const topRatedMovies = useSelector((store) => store.movies?.topRatedMovies);
  const popularMovies = useSelector((store) => store.movies?.popularMovies);
  const trendingMovies = useSelector((store) => store.movies.trendingMovies);

(!topRatedMovies || !popularMovies ||!trendingMovies) && <div className="w-full h-full flex justify-center items-center">Loading...</div>


  return (
    <div className="bg-gradient-to-b from-black to-[#060730] -mt-12 xl:-mt-80 pt-10">
      {trendingMovies && (
        <MovieList
          movieList={trendingMovies}
          title={"Trending Today"}
          sliderId={"trendingSlider"}
        />
      )}
      {popularMovies && (
        <MovieList
          movieList={popularMovies}
          title={"Popular Movies"}
          sliderId={"popularSlider"}
        />
      )}
      <div className="px-20">
        <div className=" border-b-[1px] border-gray-500"></div>
      </div>
      {topRatedMovies && (
        <MovieList
          movieList={topRatedMovies}
          title={"Top Rated"}
          sliderId={"topRatedSlider"}
        />
      )}
      <div className="px-20">
        <div className=" border-b-[1px] border-gray-500"></div>
      </div>
      {nowPlayingMovies && (
        <MovieList
          movieList={nowPlayingMovies}
          title={"Now Playing"}
          sliderId={"nowPlayingSlider"}
        />
      )}
      <div className=" border-b-[1px] border-gray-500"></div>
    </div>
  );
};

export default SecondaryContainer;

/**
 * Maybe call movie details api to get genre tagline..
 */
